/**
 * Frappe/ERP bearer token for BK Design — bridged from BengaitLabs (different origin).
 * Stored only on this origin; passed once via URL hash or query, then stripped.
 */

export const ERP_TOKEN_STORAGE_KEY = 'bengait_erp_token';

const HASH_KEYS = ['erp_token', 'access_token'];
const QUERY_KEYS = ['erp_token', 'access_token'];

/**
 * @returns {string|null}
 */
export function getErpBearerToken() {
  if (typeof window === 'undefined') return null;
  const t = localStorage.getItem(ERP_TOKEN_STORAGE_KEY);
  return t && String(t).trim() !== '' ? t : null;
}

/**
 * @param {string} token
 */
export function setErpBearerToken(token) {
  if (typeof window === 'undefined' || token == null || String(token).trim() === '') return;
  localStorage.setItem(ERP_TOKEN_STORAGE_KEY, String(token).trim());
}

export function clearErpBearerToken() {
  if (typeof window === 'undefined') return;
  localStorage.removeItem(ERP_TOKEN_STORAGE_KEY);
}

export function hasErpBearerSession() {
  return getErpBearerToken() != null;
}

/**
 * Read token from URL hash (preferred) or query, persist, then remove from address bar.
 * Call once at startup before React render (see index.jsx).
 */
export function bootstrapErpTokenFromUrl() {
  if (typeof window === 'undefined') return;

  let found = null;

  const hash = window.location.hash?.replace(/^#/, '') ?? '';
  if (hash) {
    const hp = new URLSearchParams(hash);
    for (const key of HASH_KEYS) {
      const v = hp.get(key);
      if (v) {
        found = v;
        hp.delete(key);
        break;
      }
    }
    const newHash = hp.toString() ? `#${hp.toString()}` : '';

    const url = new URL(window.location.href);
    url.hash = newHash;

    for (const key of QUERY_KEYS) {
      if (url.searchParams.has(key)) {
        const v = url.searchParams.get(key);
        if (v && !found) found = v;
        url.searchParams.delete(key);
      }
    }

    if (found) {
      setErpBearerToken(found);
    }

    const next = `${url.pathname}${url.search}${url.hash}`;
    window.history.replaceState(window.history.state, '', next);
    return;
  }

  const url = new URL(window.location.href);
  for (const key of QUERY_KEYS) {
    if (url.searchParams.has(key)) {
      const v = url.searchParams.get(key);
      if (v) {
        found = v;
        url.searchParams.delete(key);
      }
    }
  }

  if (found) {
    setErpBearerToken(found);
    const next = `${url.pathname}${url.search}${url.hash}`;
    window.history.replaceState(window.history.state, '', next);
  }
}
